import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/league-city")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in League City, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for League City & Galveston County.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — League City, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving League City and Galveston County.",
      keywords: "awnings League City, awning company League City, custom awnings League City, sail shades League City, patio covers League City, pergola covers League City, metal awnings League City, canvas awnings League City, Texas Made Shade",
    }),
    scripts: cityHeadScripts("League City", "Galveston County"),
  }),
  component: () => <CityHomePage city="League City" region="Galveston County" />,
});
